import styled from 'styled-components'
// Styled components for QuestionnaireForm
import { SubmitButton as _SubmitButton, FormItem as _FormItem } from 'formik-antd'
import { margin, screen } from '@libs/theme/mixins'
import { Typography } from 'antd'

const SubmitButton = styled(_SubmitButton)`
	margin-top: ${margin('xl')};
	align-self: center;
	width: 200px;
	${screen.lte.xxs`
		width: 100%;
	`}
`

const CenteredTitle = styled(Typography.Title)`
	text-align: center;
`

const FormItem = styled(_FormItem)`
	* {
		transition: unset !important;
	}
`

export default {
	SubmitButton,
	CenteredTitle,
	FormItem,
}
